var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout__container"},[_c('v-card',{staticClass:"mx-auto"},[_c('v-card-text',[_c('Checkout')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }